import Paragraph from './paragraph/ContractAgreementDetailParagraph';
import Select from './select/ContractAgreementDetailSelect';
import Text from './text/ContractAgreementDetailText'

export default { Paragraph, Select, Text };
